import ShipmentDetails from '../../ShipmentDetails';
import Accessorial from '../../Accessorial';
import ExcessiveLength from '../../ExcessiveLength';
import ConsigneeDetails from './ConsigneeDetails';
import { Divider } from '@material-ui/core';
import Details from './Details';
import HazmatDetails from '../../HazmatDetails';
import ExpediteShipment from '../../../Pickups/PickupInfoPopup/components/PickupDetails/ExpediteShipment';
import PackageCodes from './PackageCodes';
import { withAppConfig } from '@appConfigContext';
import { isLiftgateReasonEnabled } from '../../../DriverPopUp/common/liftgateUtils';

const ProDetails = ({ classes, DispatchStore, proDetails, isWarehousePickup, configJSON }) => {
  const enableLiftgateReason = isLiftgateReasonEnabled(configJSON);
  const enableInbondOption = configJSON.enableInbondOption;
  return (
    <>
      <ShipmentDetails proData={proDetails} isPickupPro />
      <Divider className={classes.divider} />
      <PackageCodes freightDescriptionDetails={proDetails.freightDescriptionDetails} />
      <Divider className={classes.divider} />
      {isWarehousePickup && (
        <>
          <Details label="Warehouse Shipper Name" value={proDetails.warehouseShipperName} upperCase />
          <Divider className={classes.divider} />
        </>
      )}
      <ConsigneeDetails proData={proDetails} />
      <Divider className={classes.divider} />
      <Details label="Manual Pro" value={proDetails.isManualPro ? 'Yes' : 'No'} upperCase />
      <Divider className={classes.divider} />
      {proDetails.receivedCanadianDocumentation && (
        <>
          <Details label="Canada Documents" upperCase value="Yes" />
          <Divider className={classes.divider} />
        </>
      )}
      {proDetails.receivedMexicoDocumentation && (
        <>
          <Details label="Mexico Documents" upperCase value="Yes" />
          <Divider className={classes.divider} />
        </>
      )}
      {proDetails.receivedPuertoRicoDocumentation && (
        <>
          <Details label="Peurto Rico Documents" upperCase value="Yes" />
          <Divider className={classes.divider} />
        </>
      )}
      <Accessorial
        accessorialList={DispatchStore.staticClientData ? DispatchStore.pickupAccessorials : []}
        selectedAccessorials={proDetails.accessorialDetails}
        limitedAccessList={DispatchStore.staticClientData ? DispatchStore.limitedAccessList : []}
        selectedLimitedAccessCode={proDetails.limitedAccessCode}
        liftgateReasonList={enableLiftgateReason && DispatchStore.staticClientData ? DispatchStore.liftgateReasonList : []}
        selectedLiftgateReasonCode={enableLiftgateReason ? proDetails.liftgateReasonCode : undefined}
      />
      <Divider className={classes.divider} />
      <ExcessiveLength
        excessiveLength={proDetails.excessiveLength}
        excessiveLengthFeet={proDetails.proLength ?? proDetails.excessiveProLength}
        excessiveLengthInches={proDetails.proLengthInches ?? proDetails.excessiveProLengthInches}
        isPickupPro
      />
      <Divider className={classes.divider} />
      <ExpediteShipment priority={proDetails.priority} staticClientData={DispatchStore.staticClientData}/>
      <Divider className={classes.divider} />
      <Details label="Food" value={proDetails.isFood ? 'Yes' : 'NA'} upperCase />
      <Divider className={classes.divider} />
      <Details label="Freezable" value={proDetails.isFreezable ? 'Yes' : 'NA'} upperCase />
      {enableInbondOption && (
        <>
          <Divider className={classes.divider} />
          <Details label="Inbond" value={proDetails.isInbond ? 'Yes' : 'NA'} upperCase />
        </>
      )}
      <Divider className={classes.divider} />
      <HazmatDetails hazmatInfo={proDetails.hazmatInfo ?? []} isPickupPro />
    </>
  );
};

export default withAppConfig(ProDetails);
